/*
 * Redondeo psicologico de precios convertidos por BUCKS (Qava).
 * (el archivo se llama -mxn por historia; hoy cubre MXN, COP y CLP)
 *
 * BUCKS solo sabe redondear al entero terminado en .99 (Math.round(x) - 0.01),
 * que sirve para monedas tipo dolar y no sirve para las que se hablan en miles.
 * Esto envuelve su funcion de conversion para que cada moneda caiga en precios
 * de tienda segun su propia costumbre.
 *
 * OJO: el cobro real sigue siendo en USD, el checkout de Shopify no convierte a
 * estas monedas. El precio mostrado queda por ENCIMA del cobrado.
 *
 * El enganche va por setter sobre window.bucksCC y sobre su propiedad Currency:
 * un polling llega tarde cuando la moneda ya viene fijada desde el arranque
 * (el caso del comprador real) y BUCKS pinta antes de que envolvamos. Una vez
 * pintado no hay vuelta atras: reConvert() hace early-return porque el atributo
 * bucks-currency del elemento ya coincide con la moneda destino.
 *
 * Para sumar una moneda: agregarla a REGLAS (y a FORMATOS si no debe llevar
 * decimales). Sin entrada en REGLAS, la moneda queda como la deja BUCKS.
 */
(function () {
  var REGLAS = {
    // 'centavos': monedas que se hablan por unidad. paso 50 -> 549, 899, 1049
    MXN: { tipo: 'centavos', paso: 50, minimo: 200 },
    // 'miles': monedas que se hablan de miles. -> 93.990, 156.990, 187.990
    COP: { tipo: 'miles', paso: 1000, resta: 10 },
    CLP: { tipo: 'miles', paso: 1000, resta: 10 }
  };

  // COP y CLP no usan centavos, y el separador de miles va con punto.
  var FMT_LATAM = '{{amount_no_decimals_with_comma_separator}}';
  var FORMATOS = {
    COP: { money_format: '$' + FMT_LATAM, money_with_currency_format: '$' + FMT_LATAM + ' COP' },
    CLP: { money_format: '$' + FMT_LATAM, money_with_currency_format: '$' + FMT_LATAM + ' CLP' }
  };

  function bonito(n, r) {
    if (!(n > 0)) return n;
    if (r.tipo === 'miles') {
      // debajo de un paso completo el redondeo hacia arriba distorsiona demasiado
      if (n < r.paso) return Math.round(n);
      return Math.ceil(n / r.paso) * r.paso - r.resta;
    }
    if (n < r.minimo) return Math.round(n) - 0.01; // envio y extras: .99 clasico
    return Math.ceil(n / r.paso) * r.paso - 1;
  }

  // BUCKS lee customFormats antes que sus formatos por defecto.
  var formatosPuestos = false;
  function aplicarFormatos() {
    if (formatosPuestos) return;
    formatosPuestos = true;
    try {
      var actuales = window.bucksCC.customFormats || {};
      for (var m in FORMATOS) {
        if (!actuales[m]) actuales[m] = FORMATOS[m];
      }
      window.bucksCC.customFormats = actuales;
    } catch (e) {}
  }

  function envolverFn(original) {
    if (typeof original !== 'function' || original.__qavaRedondeo) return original;
    var envuelta = function (monto, desde, hacia) {
      aplicarFormatos(); // en la 1a conversion la app ya termino de inicializarse
      var r = original.apply(this, arguments);
      var regla = REGLAS[hacia];
      if (regla && typeof r === 'number' && isFinite(r)) return bonito(r, regla);
      return r;
    };
    envuelta.__qavaRedondeo = true;
    return envuelta;
  }

  function envolver(C) {
    if (!C || C.__qavaRedondeo) return;
    C.__qavaRedondeo = true;
    if (typeof C.convert === 'function') {
      C.convert = envolverFn(C.convert);
      return;
    }
    // BUCKS asigna Currency vacio y le cuelga convert despues: esperar la funcion.
    var fn;
    try {
      Object.defineProperty(C, 'convert', {
        configurable: true,
        get: function () { return fn; },
        set: function (v) { fn = envolverFn(v); }
      });
    } catch (e) {}
  }

  // Currency puede asignarse despues de crearse bucksCC: hay que esperarla.
  function vigilarCurrency(app) {
    if (app.Currency) return envolver(app.Currency);
    var valor;
    try {
      Object.defineProperty(app, 'Currency', {
        configurable: true,
        get: function () { return valor; },
        set: function (v) { valor = v; envolver(v); }
      });
    } catch (e) {}
  }

  if (window.bucksCC) {
    vigilarCurrency(window.bucksCC);
  } else {
    var app;
    try {
      Object.defineProperty(window, 'bucksCC', {
        configurable: true,
        get: function () { return app; },
        set: function (v) { app = v; if (v) vigilarCurrency(v); }
      });
    } catch (e) {}
  }
})();
